/**
 * Perbandingan dua aturan retensi percakapan Jenna, untuk penjelasan di
 * `/admin/ai-assistant/umum`. Tidak menghapus apa pun — hanya menentukan
 * aturan mana yang lebih dulu memakan isi percakapan supaya UI bisa jujur.
 */

/**
 * `transcript` = batas transkrip server lebih ketat (isi hilang lebih dulu).
 * `inactive` = batas percakapan tidak aktif lebih ketat (percakapan utuh hilang lebih dulu).
 * `unknown` = batas transkrip belum diketahui (overview server belum terjawab).
 */
export type RetentionBite = "transcript" | "inactive" | "unknown";

/**
 * @param transcriptDays batas transkrip dari server (0/negatif = belum diketahui)
 * @param inactiveDays `AssistantSettings.retentionDays` (0 = simpan selamanya)
 */
export function retentionBite(
	transcriptDays: number,
	inactiveDays: number,
): RetentionBite {
	if (!Number.isFinite(transcriptDays) || transcriptDays <= 0) return "unknown";
	// 0 = simpan selamanya, jadi batas transkrip yang berlaku.
	if (!Number.isFinite(inactiveDays) || inactiveDays <= 0) return "transcript";
	return inactiveDays > transcriptDays ? "transcript" : "inactive";
}
